export default {
  GET_INVESTOR_GOAL_MOVEMENTS_QUERY: Symbol.for('GET_INVESTOR_GOAL_MOVEMENTS_QUERY'),
  INVESTOR_GOAL_MOVEMENTS_REPOSITORY: Symbol.for('INVESTOR_GOAL_MOVEMENTS_REPOSITORY'),
};
